module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "contents"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h3', [_vm._v("Table of Contents")])]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0004"
    }
  }, [_vm._v("The Translator’s Foreword.")])]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0005"
    }
  }, [_vm._v("The Book of The Thousand Nights and a Night")])]), _vm._v(" "), _c('ol', [_c('li', [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#/Text/Section0005"
    }
  }, [_vm._v("The Tale of the Hashish Eater.")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/Section0006"
    }
  }, [_vm._v("The Tale of Hammad the Badawi.")])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/Section0007"
    }
  }, [_vm._v("The Birds and Beasts and The Carpenter")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hermits.")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tale of the Water Fowl and The Tortoise.")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tale of the Wolf and the Fox.")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tale of the Falcon and the Partridge.")])])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tale of the Mouse and the Ichneumon")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cat and the Crow")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fox and the Crow")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Flea and the Mouse")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Saker and the Birds.")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sparrow and the Eagle")])])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hedgehog and the Wood-Pigeons")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Merchant and the Two Sharpers")])])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Thief and his Monkey")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Foolish Weaver")])])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sparrow and the Peacock")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tale of Ali Bin Bakkar and of Shams Al-Nahar.")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tale of Kamar Al Zaman")]), _c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0